<div class="container">
  <div [ngClass]="login.contraste ? 'card-panel mt-5 fundo-contraste' : 'card-panel mt-5 fundo-normal'">
    <form [formGroup]="entidadeForm" autocomplete="off">
      <div class="row">
        <div class="col-6">
          <table>
            <td style="vertical-align: middle;"><img src="assets/img/global/transferencia.png" alt="" title="" width="42"
                height="42"></td>
            <td>
              <p
                [ngClass]="this.login.contraste ? 'titulo-txt-contraste fonte-acessibilidade m-0' : 'titulo-txt-normal fonte-acessibilidade m-0'">
                TRANSFERÊNCIAS BANCÁRIAS</p>
              <p
                [ngClass]="this.login.contraste ? 'subtitulo-txt-contraste fonte-acessibilidade m-0' : 'subtitulo-txt-normal fonte-acessibilidade m-0'">
                EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}</p>
            </td>
          </table>
        </div>
        <div class="col-6">
          <button type="button" (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
          </button>
          <button type="button" (click)="voltar()" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Voltar a pesquisar" height="22"
              width="22">
            Voltar
          </button>
        </div>
      </div>
      <hr [ngClass]="this.login.contraste ? 'linha-contraste mt-1 mb-1' : 'linha-normal mt-1 mb-1'" />
      <div class="row">
        <div class="col-md-8">
          <div class="row">
            <div class="form-group col-md-4">
              <label for="data_transfere">Data Transferência</label>
              <input value="{{entidadeForm.get('data_transfere').value | date:'dd/MM/yyyy':'GMT'}}" type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                id="data_transfere">
            </div>
            <div class="form-group col-md-4">
              <label for="data_vencto">Referência</label>
              <input value="{{entidadeForm.get('data_referencia').value | date:'dd/MM/yyyy':'GMT'}}" type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                id="data_vencto">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-4 pb-0 mb-0">
              <label for="valor_transfere">Valor transferido</label>
              <input unmask="true" [imask]="imaskConfig" formControlName="valor_transferido" type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                id="valor_transferido" readonly placeholder="informe o valor" style="font-weight: bold; color: #1e88e5">
            </div>
          </div>
        </div>
      </div>
      <hr [ngClass]="this.login.contraste ? 'linha-contraste mt-1 mb-1' : 'linha-normal mt-1 mb-1'" />
      <div class="row">
        <div class="col-md-8">
          <div class="form-row mb-0 pb-0">
            <div class="form-group col-12 pt-0 mt-0 mb-0 pb-0">
              <label for="conta_pagadora">Conta Pagadora</label>
              <input *ngIf="entidade.conta_pagadora"
                value="{{entidade.conta_pagadora.orgao.codigo}} {{entidade.conta_pagadora.orgao.nome}}" readonly
                [ngClass]="this.login.contraste ? 'form-control-plaintext font-weight-bold text-white  mb-0 pb-0' : 'form-control-plaintext font-weight-bold  mb-0 pb-0'"
                type="text">
              <input *ngIf="entidade.conta_pagadora"
                value="{{entidade.conta_pagadora.agencia}} {{entidade.conta_pagadora.numero_conta}} {{entidade.conta_pagadora.banco.nome}}"
                readonly type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                id="conta_pagadora">
            </div>
          </div>
        </div>
      </div>
      <hr [ngClass]="this.login.contraste ? 'linha-contraste mt-1 mb-1' : 'linha-normal mt-1 mb-1'" />
      <div class="row">
        <div class="col-md-8">
          <div class="form-row">
            <div class="form-group col-12 pt-0 mt-0 mb-0 pb-0">
              <label for="conta_recebedora">Conta Recebedora</label>
              <input *ngIf="entidade.conta_recebedora"
                value="{{entidade.conta_recebedora.orgao.codigo}} {{entidade.conta_recebedora.orgao.nome}}" readonly
                type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext font-weight-bold text-white  mb-0 pb-0' : 'form-control-plaintext font-weight-bold  mb-0 pb-0'">
              <input *ngIf="entidade.conta_recebedora"
                value="{{entidade.conta_recebedora.agencia}} {{entidade.conta_recebedora.numero_conta}} {{entidade.conta_recebedora.banco.nome}}"
                readonly type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                id="conta_recebedora">
            </div>
          </div>
        </div>
      </div>
      <hr [ngClass]="this.login.contraste ? 'linha-contraste mt-1 mb-1' : 'linha-normal mt-1 mb-1'" />
      <div class="form-row">
        <div class="form-group col-12">
          <label for="historico">Histórico</label>
          <textarea formControlName="historico" readonly
            [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
            id="historico" rows="5"></textarea>
        </div>
      </div>
      <!-- <pre *ngIf="entidadeForm">{{ entidadeForm | json}}</pre> -->
    </form>
  </div>
</div>
